import { createSlice } from "@reduxjs/toolkit";
import { fetchNursePackagesReducer } from "../../reducer/packages/nursePackagesReducer";

import i18n from "../../i18n";
const initialState = {
  data: [],
  pagination: { page: 1, limit: 10, total: 0, totalPages: 1 },
  isLoading: false,
  error: null,
};

const nursePackagesSlice = createSlice({
  name: "nursePackages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNursePackagesReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchNursePackagesReducer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.packages || [];
        state.pagination = {
          page: action.payload?.pagination?.page || 1,
          limit: action.payload?.pagination?.limit || 10,
          total: action.payload?.pagination?.total || 0,
          totalPages:
            action.payload?.pagination?.totalPages ||
            action.payload?.pagination?.total_pages ||
            1,
        };
      })
      .addCase(fetchNursePackagesReducer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || i18n.t("toast.failedToLoadPackages");
      });
  },
});

export default nursePackagesSlice.reducer;
